import api, { setToken } from '../index';

export function certificates(token) {
  return api.get('/certificates', setToken(token));
}

export function issueCertificate(data) {
  return api.post('/certificates/issue', { program_id: data.programId }, setToken(data.token));
}

export function downloadCertificate(data) {
  // responseType: blob — інакше axios поверне PDF як зіпсований рядок.
  return api.get(`/certificates/${data.certificateId}/download`, {
    ...setToken(data.token),
    responseType: 'blob',
  });
}
